"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lightThemesArr = exports.darkThemesArr = exports.themes = void 0;
const dark_black_1 = require("./dark-black");
const dark_blue_1 = require("./dark-blue");
const dark_gray_1 = require("./dark-gray");
const dark_purple_1 = require("./dark-purple");
const light_blue_1 = require("./light-blue");
const light_gray_1 = require("./light-gray");
const light_purple_1 = require("./light-purple");
const light_white_1 = require("./light-white");
exports.themes = {
    auto: undefined,
    custom: undefined,
    'dark-black': dark_black_1.theme,
    'dark-blue': dark_blue_1.theme,
    'dark-gray': dark_gray_1.theme,
    'dark-purple': dark_purple_1.theme,
    'light-blue': light_blue_1.theme,
    'light-gray': light_gray_1.theme,
    'light-purple': light_purple_1.theme,
    'light-white': light_white_1.theme,
};
exports.darkThemesArr = [dark_black_1.theme, dark_gray_1.theme, dark_blue_1.theme, dark_purple_1.theme];
exports.lightThemesArr = [light_white_1.theme, light_gray_1.theme, light_blue_1.theme, light_purple_1.theme];
//# sourceMappingURL=index.js.map